namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.EPSStayRecapWidget = compass.defineWidget(function EPSStayRecapWidget(options) {
	var $j = jQuery;
	var d = jQuery.dom.getContext(this);
	var me = this;
	var _settings = options;

	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;
	var _df = _settings.meetingInfo.defaultDateFormatter;
	var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";
	var _depositRequired = _settings.depositInfo.depositRequired;
	var _refundable = _settings.depositInfo.refundable;
	var _merchantOfRecord = _settings.merchantOfRecord;
	
	var averageRateTemplate = '<%= averageRate %> <%= currencyCode %> | avg nightly event rate';
	var footerText;
	if (_merchantOfRecord !== null && _merchantOfRecord === 'property') {
		if (_depositRequired === true && _refundable === true) {
			footerText = 'All prices are in <%= currencyCode %>.<br>Balance charged at time of stay.<br> All costs charged by hotel';
		}
		if (_depositRequired === false && _refundable === true) {
			footerText = 'All prices are in <%= currencyCode %>.<br>All costs charged by hotel at time of stay.';
		}
		if (_depositRequired === true && _refundable === false) {
			footerText = 'All prices are in <%= currencyCode %>.<br>You will be charged shortly after completing your booking.<br>All costs charged by hotel.';
		}
		if (_depositRequired === false && _refundable === false) {
			footerText = 'All prices are in <%= currencyCode %>.<br>Total amount will be charged shortly after completing your booking.<br>All costs charged by hotel.';
		}
	} else {
		footerText = 'All prices are in <%= currencyCode %>.';
	}
	var expediaCollectProcessingCountryText = 'This payment will be processed in <%= processingCountry %>.';
	var propertyCollectProcessingCountryText = 'If you do not arrive at the property on the date your reservation is scheduled to begin, your reservation will be considered a "no-show" and payment for cancellation penalties will be processed in <%= processingCountry %>.';

	this.render = function(widgetElem) {
		// Use the lite version if we need it
		var widgetLiteClass = _settings.lite ? 'lite' : '';
		jQuery(widgetElem).addClass(widgetLiteClass);
		
		// Draw the hotel info if we are not lite
		if (_settings.lite === false) {
			var averageRateText = _.template(averageRateTemplate)({
				currencyCode: _settings.meetingInfo.currencyCode,
				averageRate: _cf(_settings.header.avgRate)
			});

			var hotel = d.div({className : "header"},
				d.div({className: "headerImgCntnr"},
					d.img({
						className: "headerImg",
						src: _settings.header.hotelThumbnail.length > 0 ? _settings.header.hotelThumbnail : _defaultImage})
				),
				d.div({className: "headerCopyCntnr"},
					d.div({className: "hotelName"}, _settings.header.hotelName),
					d.div({className: "roomType"}, _settings.header.roomType),
					d.div({className: "bedType"}, _settings.header.bedRequest === 2 ? "Bed Request: " + _settings.header.bedType : _settings.header.bedType),
					d.a({className: 'policyLink', href: '#' }, "View hotel policies &raquo;")
				),
				d.div({className : "clear"})
			);
			
			widgetElem.append(hotel);
		}

		// Draw the sections
		var widgetContent = d.div({className: 'recap'});
		var recaptDiv = d.div();
		var sections = _settings.recap.map(_drawSection);
		recaptDiv.append(sections);
		widgetContent.append(sections);
		
		var footerDiv = d.div({className: 'footerText'},
			d.div(
				_.template(footerText)({
					currencyCode: _settings.meetingInfo.currencyCode
				})
			)
		);

		if (_settings.processingCountry !== '') {
			if (_merchantOfRecord === 'expedia') {
				footerDiv.append(
					d.div(
						_.template(expediaCollectProcessingCountryText)({
							processingCountry: _settings.processingCountry
						})
					)
				);
			} else if (_merchantOfRecord === 'property') {
				footerDiv.append(
					d.br(),
					d.div({className: "propertyCollectMessage"},
						_.template(propertyCollectProcessingCountryText)({
							processingCountry: _settings.processingCountry
						})
					)
				);
			}
		}

		// Draw the footer
		var currencyInfoDiv = d.div({className: 'footer'}, footerDiv);
		widgetContent.append(currencyInfoDiv);
		
		jQuery(widgetElem).append(widgetContent);
	};
	
	var _drawSection = function(sectionData) {
		if (sectionData.lines.length < 1) return null;

		var sectionHolder = d.div({className: 'section'});
		
		if (sectionData.header) {
			var sectionHeader = d.div({className: 'sectionHeader'}, sectionData.header);
			sectionHolder.append(sectionHeader);
		}
		
		var lines = sectionData.lines.map(function(line) {
			if (((line.code === 'depositLine' || line.code === 'estimated_total') && line.value > 0) || line.code === 'amountChargedToday') {
				className = line.bold ? 'bold ' + line.code : line.key;
				return d.spaced({
					left: line.label,
					right: _cf(line.value),
					className: className
				});
			} else {
				className = line.bold ? 'bold' : line.key;
				return d.spaced({
					left: line.label,
					right: _cf(line.value),
					className: className
				});
			}
		});
		sectionHolder.append(lines);
		return sectionHolder;
	};
	
	var getEstimatedTotalValue = this.getEstimatedTotalValue = function() {
		for (var recapObjectIndex = 0; recapObjectIndex < _settings.recap.length; recapObjectIndex++) {
			var recapObject = _settings.recap[ recapObjectIndex ];
			for (var recapLineIndex = 0; recapLineIndex < recapObject.lines.length; recapLineIndex++) {
				var recapLine = recapObject.lines[recapLineIndex];
				if (recapLine.key === 'estimated_total') {
					return recapLine.value;
				}
			}
		}
		return -0.01; //This shouldn't happen, but in the event it does, the negative value should help us identity this error
	};

}, {
	WUID : 'defaultEPSStayRecapWidget',
	widgetName : 'EPSStayRecapWidget',
	imgPath : '/resources/img',
	lite: false, /*whether to show the hotel header (thumbnail, hotel info, etc. */
	recap: [],
	header: {
		hotelThumbnail: null,
		hotelName: 'Hotel Name',
		roomType: 'Some room type',
		avgRate: 420.69
	},
	processingCountry: ''
});